"use client";

import Link from "next/link";
import Image from "next/image";

export default function ShopFallbackPromo() {
  return (
    <div className="w-full max-w-2xl mx-auto mt-10 flex flex-col gap-10 px-4">

      {/* CARD 1 — Informativo */}
      <div className="rounded-2xl border border-zinc-800 p-8 bg-zinc-900/80 shadow-lg text-center">
        <h2 className="text-3xl font-bold text-white mb-3">
          Nenhum ingresso à venda ainda 🎫
        </h2>

        <p className="text-zinc-400 text-lg">
          Assim que novos ingressos forem disponibilizados, eles aparecerão aqui.
        </p>
      </div>

      {/* CARD 2 — Promoção do Álbum */}
      <div className="rounded-2xl border border-emerald-600/30 p-8 bg-gradient-to-br from-emerald-500/10 to-emerald-900/10 shadow-xl">
        <div className="flex flex-col items-center">

          <Image
            src="/cover.png"
            alt="Reggae I Wanna – NightReggaeX"
            width={350}
            height={350}
            className="rounded-xl shadow-md mb-5"
          />

          <h3 className="text-2xl font-bold text-emerald-400 mb-2">
            Você já comprou o álbum? 🎵
          </h3>

          <p className="text-zinc-300 text-center mb-6">
            O álbum <strong>Reggae I Wanna</strong> já está disponível para download. O que está esperando?
          </p>

          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">

            <Link
              href="/album/reggae-i-wanna"
              className="flex-1 sm:flex-none text-center bg-emerald-500 hover:bg-emerald-400 text-black font-semibold px-6 py-3 rounded-full transition shadow-[0_0_20px_rgba(16,185,129,0.4)]"
            >
              ✔ Comprar Álbum
            </Link>

            <Link
              href="https://open.spotify.com/intl-pt/album/3YskjpOdzwM2N2hPHAMD9A?si=I-ZKJfbNR9-rK6AFUCz1Kw"
              className="inline-flex items-center justify-center gap-2 px-7 py-3 rounded-full 
            bg-green-500 text-black font-semibold text-lg hover:bg-green-400 
            transition shadow-[0_0_25px_rgba(34,197,94,0.6)]"
            >
              🎧 Ouvir no Spotify
            </Link>

          </div>
        </div>
      </div>

    </div>
  );
}
